var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"task-status-badge-wrapper"},[_c('div',{staticClass:"task-status-badge",class:_setup.badgeClasses},[_vm._v(" "+_vm._s(_setup.label)+" ")]),(_setup.featureEnabled && _setup.dateLine)?_c('div',{staticClass:"task-status-badge__date"},[_vm._v(" "+_vm._s(_setup.dateLine)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }